/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SubscriptionCapability {
    UNKNOWN = 'unknown',
    VIEW_PREMIUM_CONTENT = 'view_premium_content',
}
